import { Profile, ScreenEvent, UserInfo } from "./interfaces";


export function getCookie(name: string) {
    let cookieValue: string | undefined;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export function canEditEvent(event: ScreenEvent, userInfo: UserInfo | undefined) {
    if (!userInfo) {
        return false;
    }
    const profile = userInfo.profile;
    if (
        !profile.department?.id ||
        !event.department?.id ||
        profile.department.id === event.department.id
      ) {
        return true;
      }
      return false;
}